"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useLongPress = require("use-long-press");
var _styles = require("@material-ui/core/styles");
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));
var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _ErrorOutline = _interopRequireDefault(require("@material-ui/icons/ErrorOutline"));
var _SttDotsButton = _interopRequireDefault(require("../SttButton/SttDotsButton"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1)
    },
    header: function header(props) {
      return {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(1.5),
        backgroundColor: props.corTexto ? (props === null || props === void 0 ? void 0 : props.cor) || theme.palette.primary.main : (0, _colorManipulator.alpha)((props === null || props === void 0 ? void 0 : props.cor) || theme.palette.primary.main, 0.3),
        "& .MuiCardHeader-action": {
          width: 25,
          height: 25,
          marginRight: theme.spacing(0.5),
          alignSelf: "center",
          "& button": {
            color: props.corTexto || (props === null || props === void 0 ? void 0 : props.cor) || theme.palette.primary.main,
            marginTop: "2px"
          }
        }
      };
    },
    content: function content(props) {
      return {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(1.5),
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        "&:last-child": {
          paddingBottom: theme.spacing(1)
        },
        backgroundColor: props.backgroundColor
      };
    },
    itemCenter: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: theme.spacing(3)
    },
    item: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      wordBreak: "break-word"
    },
    itemRight: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      wordBreak: "break-word",
      textAlign: "end"
    },
    titleContainer: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      gap: 8
    },
    title: function title(props) {
      return {
        color: (props === null || props === void 0 ? void 0 : props.corTexto) || (props === null || props === void 0 ? void 0 : props.cor) || theme.palette.primary.main
      };
    },
    subheader: function subheader(props) {
      return {
        display: "flex",
        alignItems: "center",
        paddingTop: theme.spacing(0.3),
        color: (0, _colorManipulator.alpha)((props === null || props === void 0 ? void 0 : props.corTexto) || (props === null || props === void 0 ? void 0 : props.cor) || theme.palette.primary.main, 0.9),
        fontSize: "0.6rem",
        minWidth: "100px"
      };
    },
    iconContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    errorIcon: {
      color: "#FFAB40",
      marginBottom: theme.spacing(1),
      fontSize: "1.9rem"
    },
    backdrop: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2
    },
    backdropIcon: {
      height: "48px",
      width: "48px"
    },
    overlay: {
      position: 'absolute',
      top: theme.spacing(4.5),
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(228, 228, 228, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    checkIcon: {
      fontSize: 78,
      color: theme.palette.primary.main
    },
    cardWrapper: {
      position: 'relative',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
      WebkitTouchCallout: 'none',
      WebkitTapHighlightColor: 'transparent'
    },
    desabilitado: {
      opacity: 0.5,
      backgroundColor: 'rgba(228, 228, 228, 0.6)',
      cursor: 'not-allowed',
      pointerEvents: 'none'
    }
  };
});
var SttTableCard = function SttTableCard(props) {
  var _props$selecionados, _acoes$, _acoes$2, _acoes$2$showFunction;
  var classes = useStyles(props);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    ancoraMenu = _useState2[0],
    setAncoraMenu = _useState2[1];
  var estaSelecionado = (_props$selecionados = props.selecionados) === null || _props$selecionados === void 0 ? void 0 : _props$selecionados.some(function (p) {
    var _props$row;
    return (p === null || p === void 0 ? void 0 : p.id) === ((_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.id);
  });
  var acoes = [];
  if (props.acao) {
    if (typeof props.acao === 'function' || /*#__PURE__*/_react["default"].isValidElement(props.acao)) {
      acoes = [{
        componente: props.acao
      }];
    } else {
      acoes = [props.acao];
    }
  } else {
    acoes = props.acoes || [];
  }
  var handleClickCard = function handleClickCard(event) {
    // Impede que o clique no menu de ações também ative a seleção do card
    if (event.target.closest('.MuiCardHeader-action button')) {
      return;
    }
    if (props.desabilitado) return;
    if (props.selecaoMultiplaAtiva && props.onSelecionar) {
      props.onSelecionar(props.row, !estaSelecionado);
    }
  };
  var longPressBind = (0, _useLongPress.useLongPress)(function () {
    var _props$onLongPress, _props$onSelecionar;
    if (props.desabilitado || !props.selecionavel) return;
    if (navigator.vibrate) {
      navigator.vibrate(100);
    }
    (_props$onLongPress = props.onLongPress) === null || _props$onLongPress === void 0 ? void 0 : _props$onLongPress.call(props, props.row);
    (_props$onSelecionar = props.onSelecionar) === null || _props$onSelecionar === void 0 ? void 0 : _props$onSelecionar.call(props, props.row, !estaSelecionado);
  }, {
    threshold: 500,
    captureEvent: true,
    cancelOnMovement: true,
    onStart: function onStart(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
  if (props.carregando || props.nenhumRegistroEncontrado) {
    return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      xs: 12,
      className: classes.itemCenter
    }, props.carregando ? /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null) : /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body2",
      color: "textSecondary",
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.iconContainer
    }, /*#__PURE__*/_react["default"].createElement(_ErrorOutline["default"], {
      className: classes.errorIcon
    }), /*#__PURE__*/_react["default"].createElement("strong", null, props.nenhumRegistroEncontrado)))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    onClick: handleClickCard
  }, longPressBind(), {
    className: classes.cardWrapper
  }), (estaSelecionado || props.desabilitado) && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.overlay
  }, props.desabilitado ? /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], {
    className: classes.checkIcon
  }) : /*#__PURE__*/_react["default"].createElement(_CheckCircleOutline["default"], {
    className: classes.checkIcon
  })), /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    className: "".concat(classes.root, " ").concat(props.desabilitado ? classes.desabilitado : '')
  }, /*#__PURE__*/_react["default"].createElement(_CardHeader["default"], {
    className: classes.header,
    action: acoes.length === 1 ? (_acoes$ = acoes[0]) !== null && _acoes$ !== void 0 && _acoes$.componente ? acoes[0].componente : (_acoes$2 = acoes[0]) !== null && _acoes$2 !== void 0 && (_acoes$2$showFunction = _acoes$2.showFunction) !== null && _acoes$2$showFunction !== void 0 && _acoes$2$showFunction.call(_acoes$2, props.row) ? ( /*#__PURE__*/_react["default"].createElement(acoes[0].icon, {
      onClick: function onClick() {
        return acoes[0].createOnClick(props.row);
      },
      style: {
        marginTop: 4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    })) : null : acoes.length > 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttDotsButton["default"], {
      "aria-controls": "acoes-menu",
      "aria-haspopup": "true",
      onClick: function onClick(event) {
        return setAncoraMenu(event.currentTarget);
      }
    }), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
      id: "acoes-menu",
      anchorEl: ancoraMenu,
      keepMounted: true,
      open: Boolean(ancoraMenu),
      onClose: function onClose() {
        return setAncoraMenu(null);
      }
    }, acoes.map(function (acao, idx) {
      var _acao$showFunction;
      if (acao !== null && acao !== void 0 && (_acao$showFunction = acao.showFunction) !== null && _acao$showFunction !== void 0 && _acao$showFunction.call(acao, props.row)) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: idx,
          onClick: function onClick() {
            setAncoraMenu(null);
            acao.createOnClick(props.row);
          }
        }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(acao.icon, {
          fontSize: "small"
        })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          primary: acao.title
        }));
      }
      return null;
    }))) : null,
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.titleContainer
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "h6",
      className: classes.title
    }, props.titulo), props.subtitulo && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "caption",
      className: classes.subheader
    }, props.subtitulo))
  }), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
    className: classes.content
  }, (props.conteudo || []).map(function (item, index) {
    var _item = _slicedToArray(item, 2),
      esquerda = _item[0],
      direita = _item[1];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      xs: esquerda.xs || !direita && 12 || 6,
      className: classes.item
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body2",
      color: "textSecondary"
    }, esquerda.titulo), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
      variant: "body2"
    }, esquerda.valor || ' Não informado ')), direita && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      item: true,
      xs: direita.xs || 6,
      className: classes.itemRight
    }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body2",
      color: "textSecondary"
    }, direita.titulo), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
      variant: "body2"
    }, direita.valor || ' Não informado '))));
  }))));
};
var _default = SttTableCard;
exports["default"] = _default;